import React from "react";
import { Logo } from "../brand/Logo";

/**
 * PORT NOTE (DY1.4): `renderLink` is new, for the same reason as in Navbar — a
 * bare `<a href>` inside the app is a full page reload. Omitted, the anchor
 * behaviour is unchanged.
 */
export function Footer({ blurb, columns = [], legal, builtBy, logoSrc, renderLink }) {
  return (
    <footer style={{ background: "var(--surface-inverse-alt)", color: "var(--text-inverse)" }}>
      <div style={{
        maxWidth: "var(--container-max)", margin: "0 auto",
        padding: "var(--section-padding-y) var(--section-padding-x)",
        display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 200px), 1fr))",
        gap: "var(--space-8)",
      }}>
        <div style={{ gridColumn: "1 / -1", maxWidth: "var(--measure-lede)" }}>
          <span style={{ display: "inline-block", background: "var(--canvas)", borderRadius: "var(--radius-md)", padding: "8px 12px" }}>
            <Logo size={32} src={logoSrc} />
          </span>
          {blurb && (
            <p style={{
              marginTop: "var(--space-4)", maxWidth: "var(--measure-lede)",
              fontSize: "var(--text-sm)", lineHeight: "var(--leading-relaxed)", color: "var(--cream-a80)",
            }}>{blurb}</p>
          )}
        </div>
        {columns.map((col) => (
          <div key={col.title}>
            <h4 style={{
              fontFamily: "var(--font-display)", fontSize: "var(--text-sm)",
              fontWeight: "var(--weight-bold)", textTransform: "uppercase",
              letterSpacing: "var(--tracking-widest)", color: "var(--hive)",
              marginBottom: "var(--space-3)",
            }}>{col.title}</h4>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: "var(--space-2)" }}>
              {col.links.map((l) => {
                const style = { fontSize: "var(--text-sm)", color: "var(--text-inverse)", textDecoration: "none" };
                return (
                  <li key={l.label}>
                    {renderLink
                      ? renderLink({ ...l, style })
                      : <a href={l.href} style={style}>{l.label}</a>}
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </div>
      <div style={{
        borderTop: "1px solid var(--border-inverse)", maxWidth: "var(--container-max)",
        margin: "0 auto", padding: "var(--space-6) var(--section-padding-x)",
        display: "flex", flexWrap: "wrap", justifyContent: "space-between", gap: "var(--space-4)",
        fontSize: "var(--text-xs)", color: "var(--cream-a60)",
      }}>
        <span>{legal}</span>
        <span style={{ fontFamily: "var(--font-mono)" }}>{builtBy}</span>
      </div>
    </footer>
  );
}
